/**
 * hostEnv
 *
 * The AIM project let the operator point the tool at any of several AssetPro
 * servers, so it carried a `serverConfig` with a switcher. This app is built per
 * environment and talks to exactly one API, so the equivalent here is simply
 * reading which build this is.
 *
 * It still matters on screen: the module writes to master data, and the banner
 * telling the operator whether they are about to reclassify PRODUCTION or the
 * demo server is the difference between a careful run and an accident. That
 * banner is kept, and these two functions feed it.
 */

const ENV = process.env.REACT_APP_ENVIRONMENT

export const getServerType = () =>
  ENV === 'production' ? 'production'
    : ENV === 'development' ? 'development'
      : 'demo'

export const getServerDomain = () =>
  ENV === 'production' ? 'api.theassetpro.com'
    : ENV === 'development' ? 'localhost:3002'
      : 'api.quonitrix.com'

export default { getServerType, getServerDomain }
